import { MultiSelect, SelectOptionType, Icon } from "@aidkitorg/component-library";
import { useCallback, useMemo } from "react";
import { useLocalizedStrings } from "../../../../Localization";
import { FilterWrapper } from "../../../components/FilterWrapper";

interface ChannelFilterProps {
  selectedChannels: string[];
  availableChannels: string[];
  onChannelsChange: (channels: string[]) => void;
}

export const ChannelFilter: React.FC<ChannelFilterProps> = ({
  selectedChannels,
  availableChannels,
  onChannelsChange,
}) => {
  const L = useLocalizedStrings();

  const channelOptions = useMemo(() => {
    return availableChannels.map(channel => ({
      value: channel,
      label: channel.charAt(0).toUpperCase() + channel.slice(1),
    }));
  }, [availableChannels]);

  const selectedChannelOptions = useMemo(() => {
    return channelOptions.filter(option => selectedChannels.includes(option.value));
  }, [channelOptions, selectedChannels]);

  const handleChannelsChange = useCallback((selectedOptions: SelectOptionType[]) => {
    const newChannels = selectedOptions.map(option => option.value);
    onChannelsChange(newChannels);
  }, [onChannelsChange]);

  return (
    <FilterWrapper label={L.admin_panel.notifications.channel}>
      <div className="pt-1.5">
        <MultiSelect
          hideLabel
          label={L.admin_panel.notifications.channel}
          description={L.admin_panel.notifications.filter_by_channel}
          options={channelOptions}
          value={selectedChannelOptions}
          onChange={handleChannelsChange}
          placeholder={L.admin_panel.notifications.select_channel}
          searchable={true}
        />
      </div>
    </FilterWrapper>
  );
};
